import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { Check } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-cream pt-7 pb-9 px-4 relative" data-id="element-97">
      <div className="max-w-5xl mx-auto text-center" data-id="element-98">
        <h1 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold leading-[1.1] uppercase mb-4 max-w-4xl mx-auto" data-id="element-99">
          Planificá todo tu año de{' '}
          <span className="orange-text" data-id="element-100">Acuicultura</span> hoy mismo y recuperá
          tus fines de semana.
        </h1>

        <div onClick={scrollToCompra} className="cursor-pointer max-w-2xl mx-auto mb-5 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/uGEwMnd9K4YrJECCn3XZtT/my-project-page-1_(5).png" alt="Sistema Acuicultura Pro — 6 tomos + materiales" className="w-full h-auto" data-id="element-102" />
        </div>

        <p className="text-sm md:text-lg text-brand-mute font-medium max-w-3xl mx-auto leading-snug mb-5" data-id="element-103">
          <span className="font-bold text-brand-ink" data-id="element-104">
            6 tomos técnicos listos para usar, planificación anual completa,
            actividades de campo, evaluaciones con rúbrica y proyectos
            integradores.
          </span>{' '}
          Todo en un solo sistema. Todo listo para el lunes.
        </p>

        <div className="max-w-md mx-auto mb-4" data-id="element-105">
          <Button data-id="element-106">🚀 Quiero el Sistema Acuicultura Pro</Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[11px] md:text-sm text-brand-ink font-bold tracking-wide" data-id="element-107">
          <div className="flex items-center" data-id="element-108">
            <Check className="w-4 h-4 mr-1 text-brand-green" strokeWidth={3} data-id="element-109" />{' '}
            Acceso inmediato
          </div>
          <div className="flex items-center" data-id="element-110">
            <Check className="w-4 h-4 mr-1 text-brand-green" strokeWidth={3} data-id="element-111" />{' '}
            Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-112">
            <Check className="w-4 h-4 mr-1 text-brand-green" strokeWidth={3} data-id="element-113" />{' '}
            Mercado Pago / Pago local
          </div>
        </div>
      </div>
    </section>;
}